/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomComponentMetadata
 */
export interface CustomComponentMetadata {
    /**
     * 
     * @type {string}
     * @memberof CustomComponentMetadata
     */
    taskId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomComponentMetadata
     */
    workAccess?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomComponentMetadata
     */
    isPmkTask?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentMetadata
     */
    taskName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentMetadata
     */
    techId?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentMetadata
     */
    stepMetadataType: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentMetadata
     */
    customComponent?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentMetadata
     */
    componentProps?: string;
}

/**
 * Check if a given object implements the CustomComponentMetadata interface.
 */
export function instanceOfCustomComponentMetadata(value: object): value is CustomComponentMetadata {
    if (!('stepMetadataType' in value) || value['stepMetadataType'] === undefined) return false;
    return true;
}

export function CustomComponentMetadataFromJSON(json: any): CustomComponentMetadata {
    return CustomComponentMetadataFromJSONTyped(json, false);
}

export function CustomComponentMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'workAccess': json['workAccess'] == null ? undefined : json['workAccess'],
        'isPmkTask': json['isPmkTask'] == null ? undefined : json['isPmkTask'],
        'taskName': json['taskName'] == null ? undefined : json['taskName'],
        'techId': json['techId'] == null ? undefined : json['techId'],
        'stepMetadataType': json['stepMetadataType'],
        'customComponent': json['customComponent'] == null ? undefined : json['customComponent'],
        'componentProps': json['componentProps'] == null ? undefined : json['componentProps'],
    };
}

export function CustomComponentMetadataToJSON(json: any): CustomComponentMetadata {
    return CustomComponentMetadataToJSONTyped(json, false);
}

export function CustomComponentMetadataToJSONTyped(value?: CustomComponentMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'workAccess': value['workAccess'],
        'isPmkTask': value['isPmkTask'],
        'taskName': value['taskName'],
        'techId': value['techId'],
        'stepMetadataType': value['stepMetadataType'],
        'customComponent': value['customComponent'],
        'componentProps': value['componentProps'],
    };
}

